<template>
    <div class="login-container">
        <div class="main-nav">
            <div class="main-width auto cl">
                <div class="main-nav-logo fl fm-y">
                    <img src="http://www.ljlx.com/ljlx/newlx/images/login_icon.png" class="vm">
                    <span class="ml15">乐教乐学</span>
                </div>
                <ul class="main-nav-ls">
                    <li><a href="/">乐教乐学</a></li>
                    <li><a href="/ljlx/newlx/getapp.html">应用下载</a></li>
                    <li><a href="/ljlx/newlx/news/news/">新闻资讯</a></li>
                    <li><a href="/ljlx/newlx/cooperation.html">教育合作</a></li>
                    <li><a href="/ljlx/newlx/help.html">帮助中心</a></li>
                    <!--<li><a href="/ljlx/newlx/apply.html">申请使用</a></li>-->
                </ul>
            </div>
        </div>
        <div class="login-main">
            <div class="main-width auto cl">
                <div class="login-pic">
                    乐教乐学 不仅仅是一个人人通平台。
                    它集教学管理、教学工具、教学资源、家校共育、 在线交流、趣味学习于一体；
                    助力教育局、电教馆、学校快速实现人人通部署， 免费入校培训，让老师真正常态化使用。
                </div>
                <div class="login-box">
                    <div class="login-who">
                        提示：仅限教育局人员和老师登录
                    </div>
                    <el-form label-width="40px" :model="form" :rules="rules" ref="form">
                        <el-form-item label="账号" prop="uname">
                            <el-input type="text" v-model="form.uname" @keyup.native.enter="doLogin" />
                        </el-form-item>
                        <el-form-item label="密码" prop="pword">
                            <el-input type="password" v-model="form.pword" @keyup.native.enter="doLogin" />
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" class="btn-login" @click="doLogin">登录</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            
        </div>
    
        <!--footer-->
        <!--<div class="js-include" data-include="/ljlx/newlx/inc/footer.html"></div>-->
        <div class="main-width auto surface-item6 clearfix">
            <div class="surface-links2">
                <a href="http://www.ljlx.com/ljlx/newlx/about-us.html" target="_blank">关于我们</a>  <img src="http://www.ljlx.com/ljlx/newlx/images/dot2.png">  <a href="http://www.ljlx.com/ljlx/newlx/join-us.html" target="_blank">加入我们</a>  <img src="http://www.ljlx.com/ljlx/newlx/images/dot2.png">  <a href="http://www.ljlx.com/ljlx/newlx/contact.html" target="_blank">联系我们</a>
                <!--<img src="http://www.ljlx.com/ljlx/newlx/images/dot2.png">  <a href="http://www.ljlx.com/ljlx/newlx/apply.html" target="_blank">申请使用</a>-->
            </div>
            <div class="surface-contect2 auto">
                <span class="surface-one-way"><i class="icon-tel"></i><span class="surface-ct-tip">客服电话：</span> <span>400-1515-505</span></span> <!--&nbsp;&nbsp;<span>400-6622-600</span>-->
            </div>
        </div>
        <div class="main-copy">
            Copyright 2008-2018 ljlx.com All Rights Reserved  版权所有  北京世纪飞育软件有限责任公司<br>
            <a href="http://www.miibeian.gov.cn/" target="_blank">京ICP备15032194号-1</a>&nbsp;
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802021484" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="http://www.ljlx.com/ljlx/newlx/images/jinganb.png" style="vertical-align:middle"/>京公网安备 11010802021484号</a>
        </div>
        
    </div>

</template>

<script>
    let preg=/^1\d{10}$/;
    import cookie from 'vue-cookie';
    export default {
        name: "login",
        data(){
            let checkAccount = (rule, value, callback) => {
                if (!preg.test(value)) {
                    this.form.password = '';
                    //this.pwdipttype = 'text';
                    return callback(new Error('请输入正确的手机号码！'));
                }else{
                    callback();
                }
            };
            let checkPassword = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入密码！'));
                }else{
                    callback();
                }
            };
            return {
                form:{
                    requestType: 'jsonp',
                    uname:'',
                    pword:'',
                    device_type:1
                },
                rules:{
                    uname:[{ validator: checkAccount, trigger: 'blur' }],
                    pword:[{ validator: checkPassword, trigger: 'blur' }],
                },
            }
        },
        methods:{
            async doLogin(){
                let _this = this;
                this.$showLoading();
                let xeiyi = document.location.protocol;
                $.get('/api/user/getuserinfobylogin?login_name='+this.form.uname,function(msg){
                    if(msg.result===0){
                        let roles = [3,4,11,12,13,14];
                        if(!roles.some(val=>val===msg.data.user_info.user_role)){
                            _this.$closeLoading();
                            _this.$message({
                                type:'error',
                                message:"仅限老师和教育局人员登录"
                            });
                            cookie.delete('sc1',{domain: _this.$getHost()});
                        }else{
                            $.ajax({
                                url: xeiyi + "//id."+_this.$getHost()+"/sso/login.ashx",
                                type: "get",
                                timeout: 30000,
                                dataType: "jsonp",
                                jsonp: 'callback',
                                crossDomain: true,
                                data: _this.form,
                                success: function (result) {
                                    _this.$closeLoading();
                                    if (result.trial == 1)
                                    {
                                        //_this.$closeLoading();
                                        _this.$message({
                                            type:'error',
                                            message:"检测到您使用的是试用账号，无法登录"
                                        });
                                        return false;
                                    }
                                    // 登录成功
                                    if (result.result === 0) {
                                        let roles = [3,4,11,12,13,14];
                                        if(roles.some(val=>val===result.user_role)){
                                            if (result.initialpwd) {
                                                _this.$message({
                                                    type:'error',
                                                    message:"需要初始化密码"
                                                });
                                            }
                                            else {
                                                //_this.$router.replace({path:'/'});
                                                _this.getBase();
                                            }
                                        }else{
                                            _this.$message({
                                                type:'error',
                                                message:"仅限老师和教育局人员登录"
                                            });
                                            cookie.delete('sc1',{domain: this.$getHost()});
                                        }
                                    }
                                    else {
                                        _this.$message({
                                            type:'error',
                                            message:result.msg?result.msg:"您输入的账户名和密码不匹配，请重新输入"
                                        });
                                        return false;
                                    }
                                },
                                error: function (data, status) {
                                    _this.$closeLoading();
                                    _this.$message({
                                        type:'error',
                                        message:"网络错误！请稍后重试！"
                                    });
                                    return false;
                                }
                            });
                        }
                    }else{
                        _this.$message({
                            type:'error',
                            message:msg.msg?msg.msg:'网络错误！请稍后重试！'
                        });
                        return false;
                    }
                });
                
                
                
                
                
            },
            
            //获取基本信息
            getBase(){
                this.$showLoading();
                this.$store.dispatch('getUserInfo',{self:this,cb:(msg)=>{
                        this.$closeLoading();
                        if(msg.result === 0){
                            this.$router.replace({path:'/'});
                        }
                    }})
            }
        },
        created(){
            let token = cookie.get('sc1');
            if(token){
                this.$router.replace({path:'/'});
            }
        },
        // mounted(){
        //     $(".js-include").each(function(){
        //         var $this=$(this);
        //         var url="/ljlx/newlx/inc/footer.html";
        //         $.get(url,function(msg){
        //             $this.html(msg);
        //         });
        //     });
        // }
    }
</script>

<style scoped>
    .login-container{
        position: absolute;
        left:0;top:0;right:0;bottom:0;
        overflow-y: auto;
        background:#fff;
    }
    .vm{vertical-align:middle;}.vtb{vertical-align:text-bottom;}.vt{vertical-align:top;}.vn{vertical-align:-2px;}.ma{margin-left:auto;margin-right:auto;}
    .main-width {
        width: 1200px;
    }
    .main-nav{
        height:114px;
        background:#fff;
    }
    .auto {
        margin-left: auto;
        margin-right: auto;
    }
    .main-nav-logo {
        float:left;
        font-size:32px;
        line-height:112px;
        color:#4a4a4a;
        font-family: "\5fae\8f6f\96c5\9ed1";
    }
    .main-nav-logo em {
        vertical-align: middle;
    }
    .main-nav-ls{
        float:right;
        list-style: none;
    }
    .main-nav-ls li{
        float:left;
        height:100%;
    }
    .main-nav-ls a{
        display:block;
        height:110px;
        padding:0 30px;
        line-height:110px;
        font-size:18px;
        color:#545454;
        text-decoration: none;
    }
    .main-nav-ls a:hover{
        color:#FF680D;
    }
    .main-nav-ls li.on a{
        color:#FF680D;
        border-bottom:4px solid #FF680D;
    }
    
    .login-main{
        background-color:#F2F2F2;
        min-height:500px;
        display:flex;
        justify-content: space-between;
        align-items: center;
        padding:50px 0;
    }
    .login-pic{
        float:left;
        width:400px;
        font-size:16px;
        line-height:2em;
        padding:100px;
        color:#777;
    }
    .login-box{
        float:right;
        width:360px;
        padding:50px;
        background:#fff;
        border-top:5px solid #00C6AB;
        box-shadow: 0 1px 5px rgba(0,0,0,.08);
        
    }
    .btn-login{
        display: block;
        width:100%;
    }
    .surface-item6{
        padding:50px 0 24px;
        border-bottom:2px solid #B3B3B3;
    }
    .surface-links2{
        font-size:18px;
        line-height: 108px;
        text-align: center;
    }
    .surface-links2 a{
        display:inline-block;
        *zoom:1;
        padding:0 30px;
        color:#333;
        text-decoration: none;
    }
    .surface-links2 a:hover{
        color:#f00;
    }
    .surface-contect2{
        width:349px;
    }
    .main-copy{
        text-align: center;
        line-height: 2em;
        padding:30px 0 50px;
        font-size:14px;
        color:#555;
    }
    .main-copy a{
        color:#555;
        text-decoration: none;
    }
    .main-copy-weixin{text-align:center;
        position:fixed;
        left:71px;
        top:412px;
        width:120px;
        z-index: 100;
        font-size:12px;
    }
    .main-copy-weixin img{width:100px;height:100px;}
    .login-who{
        font-size:12px;
        color:#999;
        padding:20px 0;
    }
    .surface-contect2 .surface-one-way{
        float:left;
        height:52px;
        line-height:52px;
        font-size:24px;
        margin-bottom:10px;
    }
    .icon-tel{
        background:url(http://www.ljlx.com/ljlx/newlx/images/icon-20160927.png) no-repeat;
        display:inline-block;
        *zoom:1;
        vertical-align: middle;
        margin-right:15px;
    }
    .icon-tel{
        width:51px;
        height:51px;
        background-position:0 -41px;
    }
</style>


// WEBPACK FOOTER //
// src/components/login/Login.vue